export default {
  /* eslint-disable no-dupe-keys */
  user_overview: {
    titles: {
      summary: '汇总',
      charge: '充电'
    },
    labels: {
      new_users_count: '新增用户: ',
      new_topups_count: '新增充值(人)',
      charging_users_count: '充电用户数: ',
      topups_users_count: '充值用户数: '
    },
    formats: {
      monthday: 'MM月DD日'
    }
  }
}
